export class BackupPolicyResourceSelector {
    'resourceSelectionMode';
    'expression';
    'resourceInclusionOverride';
    'resourceExclusionOverride';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelectionMode",
            "baseName": "resourceSelectionMode",
            "type": "ResourceSelectorMode",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "BackupPolicyExpression",
            "format": ""
        },
        {
            "name": "resourceInclusionOverride",
            "baseName": "resourceInclusionOverride",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceExclusionOverride",
            "baseName": "resourceExclusionOverride",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
